import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, Compass, MessageCircle, Shield } from 'lucide-react';
import { Button } from './ui/Button';
const features = [{
  icon: AlertCircle,
  title: 'El Manual del Botón de Pánico',
  desc: 'El paso a paso exacto (30-60-90 segundos) para desescalar el colapso.'
}, {
  icon: Compass,
  title: 'La Brújula de Disparadores',
  desc: 'Cómo detectar el colapso antes de que empiece (identifica si es hambre, ruido o fatiga de decisión).'
}, {
  icon: MessageCircle,
  title: 'Guiones de Supervivencia Social',
  desc: 'Qué decirle exactamente a la gente que te mira en público para recuperar tu poder y proteger a tu hijo.'
}, {
  icon: Shield,
  title: 'Tu Escudo de Calma',
  desc: 'El ejercicio de 4 segundos para que tú no entres en colapso junto con él.'
}];
export function WhatYouGet() {
  return <section className="py-20 bg-brand-cream px-6" data-id="element-216">
      <div className="max-w-5xl mx-auto" data-id="element-217">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-218">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-219">
            Esto es lo que recibes hoy
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-220">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-shadow" data-id="element-221">
              <div className="w-14 h-14 rounded-full bg-brand-sage-light flex items-center justify-center mb-6" data-id="element-222">
                <feature.icon className="text-brand-sage" size={28} data-id="element-223" />
              </div>
              <h3 className="font-bold text-2xl mb-3 font-serif" data-id="element-224">
                {feature.title}
              </h3>
              <p className="text-brand-navy/80 leading-relaxed text-lg" data-id="element-225">
                {feature.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-226">
          <Button href="#precio" data-id="element-227">Obtener acceso inmediato — $6,36 USD</Button>
        </div>
      </div>
    </section>;
}